<template>
  <div class="row" :id="'note-uuid-' + uuid">
    <div class="col-xs-10" style="padding-top: .25rem;">
      <strong>
        On {{ formatDate(note.created_at) }}, {{ userName }} wrote
      </strong>
      <p>{{  note.note }}</p>
    </div>
    <div class="col-xs-2 text-center" style="padding-top: 1rem;"
         v-if="current_user.id === note.user.id && note.deleted_at === undefined">
      <delete-note-button @click="onClickDeleteNote" @hover="onHoverDeleteButton"
                          @unhover="onUnhoverDeleteButton" :disabled="working" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Axios from '../../../packages/axios/Axios';
import GeneralTools from '../../../mixins/GeneralTools';
import DeleteNoteButton from '../../controls/DeleteNoteButton';

export default {
  components: { DeleteNoteButton },
  computed: {
    ...mapGetters(['current_user']),
    userName() {
      if (this.current_user.id === this.note.user.id) {
        return 'you';
      }
      return this.note.user.name;
    },
  },
  created() {
    this.uuid = crypto.getRandomValues(new Uint32Array(4)).join('-');
  },
  data() {
    return {
      uuid: '',
      working: false,
    };
  },
  methods: {
    onClickDeleteNote() {
      this.working = true;
      Axios.delete('/v1/reports/' + this.$route.params.reportId + '/notes/' + this.note.id);
    },
    onHoverDeleteButton() {
      document.getElementById('note-uuid-' + this.uuid).classList.add('highlighted-row');
    },
    onUnhoverDeleteButton() {
      document.getElementById('note-uuid-' + this.uuid).classList.remove('highlighted-row');
    },
  },
  mixins: [GeneralTools],
  name: 'Note',
  props: ['note'],
};
</script>

<style scoped>
.highlighted-row {
  background-color: #FFE0E0;
}
</style>
